const formHandler = () => {
    const forms = document.querySelectorAll('.Form');

    if (forms) {
        forms.forEach((i) => {
            const submitButton = i.querySelector('.Form__submit');
            const closeNotificationButton = i.querySelector('.Form__close-notification');
            const notificationWindow = i.querySelector('.Form__notification');
            const notificationText = i.querySelector('.Form__notification-text');

            const closeNotificationWindow = () => {
                notificationWindow.classList.remove('--is-visible');
            }
            const clearErrors = () => {
                const errors= i.querySelectorAll('.error-message');
                if (errors) {
                    errors.forEach((error) => {
                        error.innerHTML = '';
                    });
                }
            }

            if (closeNotificationButton) {
                closeNotificationButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    closeNotificationWindow();
                });
            }

            if (submitButton) {
                submitButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    clearErrors();
                    let data = new FormData(i);
                    fetch('index.php?route=common/home/formHandler', {
                        method: 'POST',
                        body: data
                    }).then((response) => {
                            if (!response.ok) {
                                throw new Error('Error occurred!')
                            }
                            return response.json();
                    }).then((data) => {
                            console.log(data);
                            if (!data.errors) {
                                if (data.result === 'ok') {
                                    console.log('OK!');
                                    notificationWindow.classList.add('--is-visible');
                                    notificationText.innerText = 'Заявка отправлена!';
                                    setTimeout(closeNotificationWindow, 10000);
                                } else if (data.result === 'timeerror') {
                                    console.log('TIMEERROR!');
                                    notificationWindow.classList.add('--is-visible');
                                    notificationText.innerText = 'Вы уже отправляли заявку!';
                                    setTimeout(closeNotificationWindow, 10000);
                                }
                            } else {
                                if (data.errors.telephone) {
                                    i.querySelector('input[name="telephone"] ~ .error-message').innerText = data.errors.telephone;
                                }
                                if (data.errors.email) {
                                    i.querySelector('input[name="mail"] ~ .error-message').innerText = data.errors.email;
                                }
                            }
                    }).catch((err) => {
                            console.log(err);
                    });
                });
            }
        });
    }
}

export default formHandler;
